import React, { useState, useEffect } from 'react';
import axios from '../../api/axios';
import './Shared.css';

const Comenzi = () => {
  const [comenzi, setComenzi] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedComanda, setSelectedComanda] = useState(null);

  const statusOptions = [
    { value: 'plasata', label: 'Plasată', color: '#2196F3' },
    { value: 'confirmata', label: 'Confirmată', color: '#FF9800' },
    { value: 'in preparare', label: 'În Preparare', color: '#9C27B0' },
    { value: 'livrata', label: 'Livrată', color: '#4CAF50' },
    { value: 'anulata', label: 'Anulată', color: '#F44336' }
  ];

  useEffect(() => {
    loadComenzi();
  }, []);

  const loadComenzi = async () => {
    try {
      const response = await axios.get('/api/comenzi');
      setComenzi(response.data);
    } catch (error) {
      console.error('Eroare la încărcare comenzi:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (comandaId, newStatus) => {
    try {
      await axios.patch(`/api/comenzi/${comandaId}/status`, { status: newStatus });
      loadComenzi();
      if (selectedComanda && selectedComanda._id === comandaId) {
        const response = await axios.get(`/api/comenzi/${comandaId}`);
        setSelectedComanda(response.data);
      }
    } catch (error) {
      console.error('Eroare la actualizare status:', error);
      alert('Eroare la actualizare status');
    }
  };

  const viewDetails = async (comanda) => {
    try {
      const response = await axios.get(`/api/comenzi/${comanda._id}`);
      setSelectedComanda(response.data);
    } catch (error) {
      console.error('Eroare la încărcare detalii comandă:', error);
    }
  };

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('ro-RO', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getStatusColor = (status) => {
    const option = statusOptions.find(opt => opt.value === status);
    return option ? option.color : '#666';
  };

  if (loading) return <div>Se încarcă...</div>;

  return (
    <div>
      <div className="page-header">
        <h1>Gestiune Comenzi</h1>
        <p>Vizualizează și gestionează comenzile</p>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr>
              <th>Data</th>
              <th>Clasă</th>
              <th>Grădiniță</th>
              <th>Educatoare</th>
              <th>Porții</th>
              <th>Total</th>
              <th>Status</th>
              <th>Acțiuni</th>
            </tr>
          </thead>
          <tbody>
            {comenzi.map((comanda) => (
              <tr key={comanda._id}>
                <td>{formatDate(comanda.data)}</td>
                <td>{comanda.clasa?.numeClasa}</td>
                <td>{comanda.clasa?.numeGradinita}</td>
                <td>{comanda.educatoare?.nume}</td>
                <td>{comanda.totalPortii}</td>
                <td>{comanda.pretTotal.toFixed(2)} lei</td>
                <td>
                  <select
                    value={comanda.status}
                    onChange={(e) => handleStatusChange(comanda._id, e.target.value)}
                    style={{
                      padding: '6px 10px',
                      borderRadius: '6px',
                      border: '1px solid #ddd',
                      backgroundColor: getStatusColor(comanda.status),
                      color: 'white',
                      fontWeight: '500'
                    }}
                  >
                    {statusOptions.map(opt => (
                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                  </select>
                </td>
                <td>
                  <button className="btn btn-secondary btn-sm" onClick={() => viewDetails(comanda)}>
                    Detalii
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedComanda && (
        <div className="modal-overlay" onClick={() => setSelectedComanda(null)}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Detalii Comandă</h2>
              <button className="modal-close" onClick={() => setSelectedComanda(null)}>&times;</button>
            </div>
            <div className="comanda-details">
              <div className="detail-row">
                <strong>Data:</strong> {formatDate(selectedComanda.data)}
              </div>
              <div className="detail-row">
                <strong>Grădiniță:</strong> {selectedComanda.clasa?.numeGradinita}
              </div>
              <div className="detail-row">
                <strong>Clasă:</strong> {selectedComanda.clasa?.numeClasa}
              </div>
              <div className="detail-row">
                <strong>Educatoare:</strong> {selectedComanda.educatoare?.nume}
              </div>
              <div className="detail-row">
                <strong>Status:</strong>
                <span style={{
                  padding: '4px 12px',
                  borderRadius: '6px',
                  backgroundColor: getStatusColor(selectedComanda.status),
                  color: 'white',
                  marginLeft: '10px'
                }}>
                  {statusOptions.find(opt => opt.value === selectedComanda.status)?.label}
                </span>
              </div>
              
              <h3 style={{marginTop: '20px', marginBottom: '10px'}}>Articole Comandate:</h3>
              <table>
                <thead>
                  <tr>
                    <th>Articol</th>
                    <th>Categorie</th>
                    <th>Preț/porție</th>
                    <th>Număr Porții</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedComanda.items.map((item, index) => (
                    <tr key={index}>
                      <td>{item.meniu?.nume || item.numeArticol}</td>
                      <td>{item.categorie}</td>
                      <td>{item.pret.toFixed(2)} lei</td>
                      <td>{item.numarPortii}</td>
                      <td>{(item.pret * item.numarPortii).toFixed(2)} lei</td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <div className="detail-row" style={{marginTop: '20px', fontSize: '1.1rem'}}>
                <strong>Total Porții:</strong> {selectedComanda.totalPortii}
              </div>
              <div className="detail-row" style={{fontSize: '1.2rem', color: '#4CAF50'}}>
                <strong>Total Comandă:</strong> {selectedComanda.pretTotal.toFixed(2)} lei
              </div>

              {selectedComanda.observatii && (
                <div className="detail-row" style={{marginTop: '20px'}}>
                  <strong>Observații:</strong>
                  <p style={{marginTop: '8px', padding: '10px', backgroundColor: '#f5f5f5', borderRadius: '6px'}}>
                    {selectedComanda.observatii}
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Comenzi;
